'use strict'

import angular from 'angular'

angular.module('publishToDashboards.services', [])

angular.module('publishToDashboards', ['publishToDashboards.services'])